export default "__VITE_ASSET__Bg6xhxNl__"